import { useEffect, useState, useRef, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { CartContext } from '../../CartContext';
import { saveOrderToFirebase } from '../../firebaseUtils';
import { FaPrint } from "react-icons/fa";

function Success() {
  const { setCartProducts } = useContext(CartContext);
  const [orderNumber, setOrderNumber] = useState(null);
  const [Status, setStatus]= useState(null);
  const [moto,setMoto]=useState(null);
  const [confirmationNumber, setConfirmationNumber] = useState(null);
  const [myArr, setMyArr] = useState(null);
  const [id, setMyId] = useState(null);
  const [shippingRate, setShippintRate] = useState(null);
  const [address, setAddress] = useState(null);
  const [custEmail,setCustEmail]=useState(null)
  const [customerDetails, setCustomerDetails] = useState(null);
  const location = useLocation();
  const emailSentRef = useRef(false); // Prevent duplicate sending
  const cardRef = useRef();
   const [htmlBody, setHtmlBody] = useState('');
      const [htmlBody2, setHtmlBody2] = useState('');
  // Step 1: Parse query parameters and set state
  useEffect(() => {
    localStorage.removeItem("cart");
    setCartProducts([]);

    const queryParams = new URLSearchParams(location.search);
    const orderNumber = queryParams.get('order_number');
    const status = queryParams.get('status');
    const cust = queryParams.get('cust');
    const session = queryParams.get('session_id');
    const add = JSON.parse(decodeURIComponent(queryParams.get('address')));
    const confirmationNumber = queryParams.get('confirmation_number');
    const myArr = JSON.parse(decodeURIComponent(queryParams.get('myArr')));
    const shipping = queryParams.get('shipping');

    setOrderNumber(orderNumber);
    setStatus(status)
    setMyId(session);
    setAddress(add);
    setConfirmationNumber(confirmationNumber);
    setMyArr(myArr);
    setShippintRate(shipping)
    setCustEmail(cust)
  }, [location]);
const ideas=["Best Wishes", "With Wonder & Gratitude","With Style & Love","Always in Style, Always Grateful","Stay Wonderful","Wearing Our Thanks","Wonderfully Yours","With Love, From Wear & Wonder","Thanks for Wearing the Wonder","Wrapped in Wonder & Thanks","Your Style, Our Thanks"]
 
  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * ideas.length);
    setMoto(ideas[randomIndex]);
  }, []);

// Step 2: Wait until all required state is loaded, then call fetch
  useEffect(() => {
    if (
      !emailSentRef.current &&
      orderNumber &&
      confirmationNumber &&
      myArr &&
      address &&
      id &&
      shippingRate &&
      custEmail &&
            Status
    ) {
      fetchSessionData(id, orderNumber, confirmationNumber, myArr, address, shippingRate,custEmail, Status);
    }
  }, [orderNumber, confirmationNumber, myArr, address, id, shippingRate, custEmail, Status]);

  // Step 3: Fetch Stripe session data, send email + save to Firebase
  const fetchSessionData = async (
    session_id,
    orderNumber,
    confirmationNumber,
    myArr,
    address,
    shippingRate,
    custEmail,
        Status,
  ) => {
    
    try {
      const response = await fetch(
        `https://api-shipping-28612190fdf4.herokuapp.com/successStrp?session_id=${session_id}&orderNumber=${orderNumber}&confirmationNumber=${confirmationNumber}&myArr=${encodeURIComponent(JSON.stringify(myArr))}&address=${encodeURIComponent(JSON.stringify(address))}&shipping=${shippingRate}&cust=${custEmail}&status=${Status}`
      );

      if (!response.ok) {
        console.error('Error: Failed to fetch data', response.status);
        return;
      }

      const data = await response.json();
      setCustomerDetails(data.customerDetails);

      if (data.customerDetails) {
        // Prevent duplicate actions
        emailSentRef.current = true;

        // ✅ Save to Firebase
        await saveOrderToFirebase(
          orderNumber,
          confirmationNumber,
          myArr,
          data.customerDetails,
          address,
          shippingRate,
          custEmail,
                    Status,
        );
        // console.log('🔥 Order saved to Firebase');

        // ✅ Send Email
sendEmail(
  orderNumber,
  Status,
  confirmationNumber,
  myArr,
  data.customerDetails,
  address,
  shippingRate,
  custEmail
);

      }
    } catch (error) {
      console.error('Error fetching session data:', error);
    }
  };
  const EmailPreview = ({ html }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      style={{ border: '1px solid #ccc', padding: '1rem', marginTop: '1rem' }}
    />
  );
};
const generateItemsTableHTML = (items) => {
  return `
    <table style="border-collapse: collapse; width: 100%; font-size: 14px;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px;">ID</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Color</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Price</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Quantity</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Size</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Style</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Thumb ID</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Rating</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Weight</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Garment Price</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Image Price</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Thumb Image</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Sale Price</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Uploaded Image URL</th>
         
        </tr>
      </thead>
      <tbody>
        ${items.map(item => `
          <tr>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[0]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[1]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[2]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[3]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[4]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[5]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[6]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[7]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[8]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[9]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[10]}</td>

            <td style="border: 1px solid #ddd; padding: 8px;"><img src="https://www.wearandwonder.shop/images/All/${item[11]}" alt="Thumb" width="50"/></td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[12]}</td>


             <td style="border: 1px solid #ddd; padding: 8px;"><a href="${item[14]}">Image</a></td>
          </tr>
        `).join('')}
      </tbody>
    </table>
  `;
};

const generateItemsTableHTML2 = (items) => {
  return `
    <table style="border-collapse: collapse; width: 100%; font-size: 14px;">
      <thead>
        <tr style="background-color: #f2f2f2;">
          <th style="border: 1px solid #ddd; padding: 8px;">ID</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Color</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Price</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Quantity</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Size</th>
          <th style="border: 1px solid #ddd; padding: 8px;">Uploaded Image URL</th>
                 
          </tr>
      </thead>
      <tbody>
        ${items.map(item => `
          <tr style="background-color: #f2f2f2;">
            <td style="border: 1px solid #ddd; padding: 8px;">${item[0]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[1]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[2]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[3]}</td>
            <td style="border: 1px solid #ddd; padding: 8px;">${item[4]}</td>

                        <td style="border: 1px solid #ddd; padding: 8px;"><a href="${item[14]}">Image</a></td>
          </tr>
        `).join('')}
      </tbody>
    </table>
  `;
};
  // Step 4: Send confirmation email
  // const sendEmail = (orderNumber, Status, confirmationNumber, myArr, customerDetails, address,shippingRate,custEmail) => {
  //   const emailData = {
  //     from_name: 'Online Store',
  //     to_name: 'Payam',
  //     message: `
  //       Order Number: ${orderNumber}
  //       Status: ${Status}
  //       Confirmation Number: ${confirmationNumber}
  //       Shipping: $${shippingRate}
  //       Items: ${myArr}
  //     ------
  //       Customer Details:
  //       Email from App-login: ${custEmail}
  //         Name: ${customerDetails.name}
  //         Email: ${customerDetails.email} 
  //         Phone: ${customerDetails.phone}
  //       Shipping Address:
  //         ${address.name}
  //         ${address.street1}
  //         ${address.street2 || ''}
  //         ${address.city}
  //         ${address.zip}
  //         ${address.state}
  //         ${address.country}
  //       Billing Address:
  //         ${customerDetails.address.line1}
  //         ${customerDetails.address.line2 || ''}
  //         ${customerDetails.address.city}
  //         ${customerDetails.address.postal_code}
  //         ${customerDetails.address.state}
  //         ${customerDetails.address.country}
  //     ------
  //     Success URL: ${customerDetails.success_url}
  //     `,
  //   };

  //   emailjs
  //     .send('service_ra0tzqd', 'template_dcrf6kr', emailData, 'K6B2QrefJnYCDCTa1')
  //     .then(response => {
  //       console.log('✅ Email sent successfully', response);
  //     })
  //     .catch(error => {
  //       console.error('❌ Error sending email:', error);
  //     });
  // };
const sendEmail = (orderNumber, Status, confirmationNumber, myArr, customerDetails, address, shippingRate, custEmail) => {
  const itemsTable = generateItemsTableHTML(myArr);
  const itemsTable2 = generateItemsTableHTML2(myArr);
// 
  const body = `
    <div style="font-family: Arial, sans-serif;">
      <h2>Order Confirmation</h2>
      <p><strong>Order Number:</strong> ${orderNumber}</p>
      <p><strong>Status:</strong> ${Status}</p>
      <p><strong>Confirmation Number:</strong> ${confirmationNumber}</p>
      <p><strong>Shipping:</strong> $${shippingRate}</p>
      <h3>Items</h3>
      ${itemsTable}
      <hr/>
      <h3>Customer Details</h3>
      <p><strong>Email from App-login:</strong> ${custEmail}</p>
      <p><strong>Name:</strong> ${customerDetails.name}</p>
      <p><strong>Email:</strong> ${customerDetails.email}</p>
      <p><strong>Phone:</strong> ${customerDetails.phone}</p>

      <h3>Shipping Address</h3>
      <p>${address.name}<br/>
         ${address.street1}<br/>
         ${address.street2 || ''}<br/>
         ${address.city}, ${address.state} ${address.zip}<br/>
         ${address.country}
      </p>

      <h3>Billing Address</h3>
      <p>${customerDetails.address.line1}<br/>
         ${customerDetails.address.line2 || ''}<br/>
         ${customerDetails.address.city}, ${customerDetails.address.state} ${customerDetails.address.postal_code}<br/>
         ${customerDetails.address.country}
      </p>

      <p><strong>Success URL:</strong> ${customerDetails.success_url}</p>
    </div>
  `;
  // const body2 = `
  //   <div style="font-family: Arial, sans-serif;">
  //         <a
  //       style="text-decoration: none; outline: none; margin-right: 8px; vertical-align: middle"
  //       href="https://www.wearandwonder.shop/"
  //       target="_blank"
  //     >
  //       <img
  //         style="height: 32px; vertical-align: middle"
  //         height="40px"
  //         src='https://www.wearandwonder.shop/images/assets/wawLogo.png'
  //         alt="logo"
  //       />
  //     </a>
  //     <h3>Thank You for Your Order</h3>
  //     <h4>We'll send you tracking information when the order ships.</h4> 
  //     <p><strong>Order Number:</strong> ${orderNumber}</p>
  //     <p><strong>Confirmation Number:</strong> ${confirmationNumber}</p>
  //     ${itemsTable2}
  //     <hr/>
  //     <h3>Shipping Address</h3>
  //     <p  style="color: #000000">${address.name}<br/>
  //        ${address.street1}<br/>
  //        ${address.street2 || ''}<br/>
  //        ${address.city}, ${address.state} ${address.zip}<br/>
  //        ${address.country}
  //     </p>

  //     <h3>Billing Address</h3>
  //     <p  style="color: #000000">${customerDetails.address.line1}<br/>
  //        ${customerDetails.address.line2 || ''}<br/>
  //        ${customerDetails.address.city}, ${customerDetails.address.state} ${customerDetails.address.postal_code}<br/>
  //        ${customerDetails.address.country}
  //     </p>
  //   </div>
  //     <div style="max-width: 600px; margin: auto">
  //   <p style="color: #999">
  //     You received this email because you placed the order
  //   </p>
  // </div>
  // `;
  
  const body2 = `
  <div style="
    font-family: Arial, sans-serif;
    background-image: url('https://www.wearandwonder.shop/images/assets/p1.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 40px;
    color: #000;
  ">
    <a
      style="text-decoration: none; outline: none; margin-right: 8px; vertical-align: middle"
      href="https://www.wearandwonder.shop/"
      target="_blank"
    >
      <img
        style="height: 32px; vertical-align: middle"
        height="40px"
        src="https://www.wearandwonder.shop/images/assets/wawLogo.png"
        alt="logo"
      />
    </a>
    <h3>Thank You for Your Order</h3>
    <h4>We'll send you tracking number in your dashboard when the order ships.</h4> 
    <p><strong>Order Number:</strong> ${orderNumber}</p>
    <p><strong>Confirmation Number:</strong> ${confirmationNumber}</p>
    ${itemsTable2}
    <hr/>
    <h3>Shipping Address</h3>
    <p style="color: #000000">${address.name}<br/>
       ${address.street1}<br/>
       ${address.street2 || ''}<br/>
       ${address.city}, ${address.state} ${address.zip}<br/>
       ${address.country}
    </p>

    <h3>Billing Address</h3>
    <p style="color: #000000">${customerDetails.address.line1}<br/>
       ${customerDetails.address.line2 || ''}<br/>
       ${customerDetails.address.city}, ${customerDetails.address.state} ${customerDetails.address.postal_code}<br/>
       ${customerDetails.address.country}
    </p>

    <div style="max-width: 600px; margin: auto; color: #75787B">
      <p>You received this email because you placed the order</p>
    </div>
        <div style="max-width: 600px; margin: auto; color: #53565A">
      <p>${moto},</p>
    </div>
        <div style="max-width: 600px; margin: auto; color: #53565A">
      <p>Sales team!</p>
    </div>
  </div>
`;

  setHtmlBody(body);
    setHtmlBody2(body2);


  const emailData = {
    from_name: 'Wear & Wonder Boutiqu',
    to_name: 'Payam',
    html_body: body, // use this variable in your EmailJS template
  };
  const emailData2 = {
    from_name: 'Wear & Wonder Boutiqu',
    to_name: customerDetails.name,
    to_email: customerDetails.email || custEmail,
    html_body: body2, // use this variable in your EmailJS template
  };
  emailjs
    .send('service_ra0tzqd', 'template_dcrf6kr', emailData, 'K6B2QrefJnYCDCTa1')
    .then(response => {
      console.log('✅ Email sent successfully', response);
    })
    .catch(error => {
      console.error('❌ Error sending email:', error);
    });
      emailjs
    .send('service_ra0tzqd', 'template_04sjurs', emailData2, 'K6B2QrefJnYCDCTa1')
    .then(response => {
      console.log('✅ Email sent to customer successfully', response);
    })
    .catch(error => {
      console.error('❌ Error sending email to customer:', error);
    });
};


  const handlePrint = async () => {
    const element = cardRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL('image/png');

    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('confirmation.pdf');
  };
  return (
    // <div
    //   style={{
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     // height: '22vh',
    //     textAlign: 'center',
    //   }}
    // >
    //   <img style={{ maxWidth: 50, marginTop: 12 }} src="/images/assets/Capture20.PNG" alt="success" />
    //   <h1 style={{ color: '#88B04B', fontFamily: 'Nunito Sans', fontWeight: '900', fontSize: 40 }}>
    //     Payment Successful
    //   </h1>
    //   <p
    //     style={{
    //       color: '#404F5E',
    //       fontFamily: 'Nunito Sans',
    //       fontSize: 20,
    //       margin: 0,
    //       marginBottom: 20,
    //     }}
    //   >
    //     We received your purchase request;
    //     <br />
    //     we'll be in touch shortly!
    //     <br />
    //     Order Number: <b>{orderNumber}</b>
    //     <br />
    //     Confirmation Number: <b>{confirmationNumber}</b>
    //   </p>
    //   <FaPrint />
    // </div>
      <div
      ref={cardRef}
      style={{
        maxWidth: '600px',
        margin: '2rem auto',
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
        position: 'relative',
        fontFamily: 'Nunito Sans, sans-serif',
        color: '#404F5E',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <img
          src="/images/assets/Capture20.PNG"
          alt="success"
          style={{ maxWidth: 50, marginBottom: 12 }}
        />
        <h1 style={{ color: '#88B04B', fontWeight: 900, fontSize: 40 }}>
          Payment Successful
        </h1>
        <p style={{ fontSize: 18, margin: '1rem 0' }}>
          We received your purchase request; <br />
          we'll be in touch shortly!
        </p>
      </div>

      <table
        style={{
          width: '100%',
          marginTop: '1.5rem',
          borderCollapse: 'collapse',
          fontSize: 16,
        }}
      >
        <tbody>
          <tr>
            <td style={{ padding: '8px 0', fontWeight: 'bold' }}>Order Number:</td>
            <td style={{ padding: '8px 0' }}>{orderNumber}</td>
          </tr>
          <tr>
            <td style={{ padding: '8px 0', fontWeight: 'bold' }}>Confirmation Number:</td>
            <td style={{ padding: '8px 0' }}>{confirmationNumber}</td>
          </tr>
        </tbody>
      </table>

      <button
        onClick={handlePrint}
        style={{
          position: 'absolute',
          bottom: '1rem',
          right: '1rem',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#888',
          fontSize: 18,
        }}
        title="Print or Save as PDF"
      >
        <FaPrint />
      </button>
    </div>
  );
}

export default Success;
